import type {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import type {SmartMailingListsState} from './mailing-list-contacts-reducer';
import {handleSignupFormUpdate} from './mailing-list-contacts-reducer';
import {
  fetchCustomFieldsMeta,
  fetchSignupFormsUpdateInformationForUser,
  fetchSignupFormUpdateInformation,
  getSmartMailingListsForUser,
  getUserCreatedMailingLists,
  getUserSignupForms,
} from '@Components/mailing-list-contacts/mailing-list-contacts-thunk';
import type {SmartMailingListTypes} from '@Components/mailing-list-contacts/mailing-list-contacts.types';
import {mailingListOrder} from '@Components/mailing-list-contacts/mailing-list-contacts.types';

export const smartMailingListsExtraReducers = (builder: ActionReducerMapBuilder<SmartMailingListsState>): void => {
  builder
    .addCase(getSmartMailingListsForUser.fulfilled, (state, action): void => {
      const mailingListsInfo = action.payload.smartMailingListsInfo;

      if (mailingListsInfo) {
        state.smartMailingListsTooltipMap = mailingListsInfo;

        const idToTypeMap = Object.entries(mailingListsInfo).reduce<Record<number, SmartMailingListTypes>>((acc, [type, id]) => {
          acc[id] = type as SmartMailingListTypes;
          return acc;
        }, {});

        const sortedMailingLists = [...action.payload.mailingLists].sort((a, b) => {
          const typeA = idToTypeMap[a.id];
          const typeB = idToTypeMap[b.id];

          const indexA = mailingListOrder.indexOf(typeA);
          const indexB = mailingListOrder.indexOf(typeB);

          return indexA - indexB;
        });

        state.smartMailingLists = sortedMailingLists;
      } else {
        state.smartMailingLists = action.payload.mailingLists;
      }
    })
    .addCase(getUserCreatedMailingLists.fulfilled, (state, action): void => {
      if (state.userMailingLists) {
        state.userMailingLists = [...state.userMailingLists, ...action.payload.mailingLists];
      } else {
        state.userMailingLists = action.payload.mailingLists;
      }

      state.hasMoreMailingListsOnServer = action.payload.hasMore;
      state.shouldLoadMoreMailingLists = false;
    })
    .addCase(getUserSignupForms.fulfilled, (state, action): void => {
      if (state.signupForms) {
        state.signupForms = [...state.signupForms, ...action.payload.signupForms];
      } else {
        state.signupForms = action.payload.signupForms;
      }

      state.hasMoreSignupFormsOnServer = action.payload.hasMore;
      state.shouldLoadMoreSignupForms = false;
    })
    .addCase(fetchSignupFormUpdateInformation.fulfilled, (state, action): void => {
      handleSignupFormUpdate(state, action.payload);
    })
    .addCase(fetchSignupFormUpdateInformation.rejected, (_state): void => {
      console.error("Error fetching signup form update information for user's signup forms.");
    })
    .addCase(fetchCustomFieldsMeta.fulfilled, (state, action): void => {
      state.userCustomFieldMeta = action.payload;
    })
    .addCase(fetchSignupFormsUpdateInformationForUser.fulfilled, (state, action): void => {
      if (action.payload.hasNewActivity) {
        state.shouldShowSidebarActivityIndicator = true;
      } else {
        state.shouldShowSidebarActivityIndicator = false;
      }
    })
    .addCase(fetchSignupFormsUpdateInformationForUser.rejected, (state): void => {
      state.shouldShowSidebarActivityIndicator = false;
    });
};
